import FileMetaDTO from "@/dto/files/FileMetaDTO";

export default class CreateCustomRequestPayload {
    title: string | null = null;
    description: string | null = null;
    assigneeId: number | null = null;
    expirationDate: Date | null = null;
    files: FileMetaDTO[] = [];
}